/** Совпадает с whiteboard canvas-board-game-data.util: снимок сессии доски */
export const BOARD_GAME_DATA_TYPE = 'whiteboard:game-data';
export const BOARD_GAME_NEED_DATA_TYPE = 'whiteboard:need-game-data';

export type BoardGameDataMessage = {
  type: typeof BOARD_GAME_DATA_TYPE;
  sessionId: string;
  gameData: unknown;
};

export function buildNeedBoardGameData(sessionId: string) {
  return { type: BOARD_GAME_NEED_DATA_TYPE, sessionId };
}

/** сессия есть раньше снимка — повторяем need-data, пока parent не ответит */
export const NEED_BOARD_GAME_POLL_MS = 300;
export const LOAD_BOARD_GAME_TIMEOUT_MS = 20_000;

export function isBoardGameDataMessage(
  data: unknown,
  sessionId: string
): data is BoardGameDataMessage {
  if (!data || typeof data !== 'object') return false;
  const msg = data as BoardGameDataMessage;
  return (
    msg.type === BOARD_GAME_DATA_TYPE &&
    msg.sessionId === sessionId &&
    msg.gameData != null
  );
}

type SnapshotSection = {
  content?: {
    type?: unknown;
    answer_hash?: unknown;
    left?: unknown;
    right?: unknown;
  } | null;
};

type SnapshotGame = {
  slides?: Array<{ sections?: SnapshotSection[] }>;
  options?: { canNavigate?: boolean; [key: string]: unknown };
};

/** gamelib зовёт answer_hash.includes / [...left] — пустые массивы, если meetings не дописал */
export function normalizeBoardGameSnapshot<T extends SnapshotGame>(game: T): T {
  for (const slide of game.slides ?? []) {
    for (const section of slide.sections ?? []) {
      const content = section.content;
      if (!content || typeof content !== 'object') continue;
      if (!Array.isArray(content.answer_hash)) content.answer_hash = [];
      if ('left' in content || 'right' in content) {
        if (!Array.isArray(content.left)) content.left = [];
        if (!Array.isArray(content.right)) content.right = [];
      }
    }
  }
  // старые снимки meetings без canNavigate — иначе *ngIf прячет навбар
  game.options = { canNavigate: true, ...game.options };
  return game;
}
